import review1 from 'src/images/pngs/testimonials/review-1.png';
import review2 from 'src/images/pngs/testimonials/review-2.png';
import review3 from 'src/images/pngs/testimonials/review-3.png';
import review4 from 'src/images/pngs/testimonials/review-4.png';
import review5 from 'src/images/pngs/testimonials/review-5.png';
import review6 from 'src/images/pngs/testimonials/review-6.png';
import review7 from 'src/images/pngs/testimonials/review-7.png';
import review8 from 'src/images/pngs/testimonials/review-8.png';
import review9 from 'src/images/pngs/testimonials/review-9.png';
import review10 from 'src/images/pngs/testimonials/review-10.png';
import review11 from 'src/images/pngs/testimonials/review-11.png';
import review12 from 'src/images/pngs/testimonials/review-12.png';
import review13 from 'src/images/pngs/testimonials/review-13.png';
import review14 from 'src/images/pngs/testimonials/review-14.png';
import review15 from 'src/images/pngs/testimonials/review-15.png';
import review16 from 'src/images/pngs/testimonials/review-16.png';
import review17 from 'src/images/pngs/testimonials/review-17.png';
import review18 from 'src/images/pngs/testimonials/review-18.png';

export const testimonials: string[][] = [
  [review1, review2],
  [review3, review4],
  [review5, review6],
  [review7, review8],
  [review9, review10],
  [review11, review12],
  [review13, review14],
  [review15, review16],
  [review17, review18],
];
